import { render, staticRenderFns } from "./TopMonthActivitiesSlide.vue?vue&type=template&id=577ca084&scoped=true&"
import script from "./TopMonthActivitiesSlide.vue?vue&type=script&lang=js&"
export * from "./TopMonthActivitiesSlide.vue?vue&type=script&lang=js&"
import style0 from "./TopMonthActivitiesSlide.vue?vue&type=style&index=0&id=577ca084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577ca084",
  null
  
)

export default component.exports